export interface IFailureModeOption {
  id: string;
  label: string;
}

export const FAILURE_MODES_LIST: IFailureModeOption[] = [
  { id: '0.0', label: '0.0 Acessórios e outros' },
  { id: '1.0', label: '1.0 Motor' },
  { id: '1.1', label: '1.1 Embreagem (embreagem, incluindo sistema de acionamento)' },
  { id: '10.0', label: '10.0 Revisão' },
  { id: '11.0', label: '11.0 Software' },
  { id: '12.0', label: '12.0 Sinistro' },
  { id: '13.0', label: '13.0 Ação de campo' },
  { id: '2.0', label: '2.0 Combustível, gás de escape e arrefecimento (pós tratamento)' },
  { id: '2.1', label: '2.1 Pós-tratamento' },
  { id: '3.0', label: '3.0 Caixa de mudança' },
  { id: '4.0', label: '4.0 Eixo e caixa de direção' },
  { id: '4.1', label: '4.1 Sistema de suspensão dianteira' },
  { id: '4.2', label: '4.2 Sistema de direção' },
  { id: '5.0', label: '5.0 Eixo traseiro' },
  { id: '5.1', label: '5.1 Rolamento de roda' },
  { id: '5.2', label: '5.2 Sistema de suspensão traseira' },
  { id: '6.0', label: '6.0 Sistema de freio e circuito pneumático' },
  { id: '7.0', label: '7.0 Sistema de alavanca (pedaleira e cabos de marcha)' },
  { id: '8.0', label: '8.0 Carroceria' },
  { id: '8.1', label: '8.1 Chassi' },
  { id: '9.0', label: '9.0 Sistema elétrico' },
];

